import { render, staticRenderFns } from "./CriarMensagem.vue?vue&type=template&id=6870a19a&"
import script from "./CriarMensagem.vue?vue&type=script&lang=js&"
export * from "./CriarMensagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports